import { Badge } from '@mantine/core';
import { useTranslation } from 'react-i18next';
import type { LicensePlateStatus } from './api';

const COLOR: Record<LicensePlateStatus, string> = {
  open: 'green',
  closed: 'gray',
  disposed: 'red',
};

/**
 * One rendering of a plate's state, shared by the list and the detail modal so the colours cannot
 * drift apart. Disposed is red rather than grey because it is the only irreversible one.
 */
export function LicensePlateStatusBadge({ status }: { status: LicensePlateStatus }) {
  const { t } = useTranslation();
  return (
    <Badge color={COLOR[status]} variant="light">
      {t(`licensePlates.status.${status}`)}
    </Badge>
  );
}
